<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "AluguelEquipamentoContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
		drawer: false,
		group: null,
		value: 0,
	}),
	methods: {
		montarMenu() {
			let m = [];

			if (this.permissao("aluguel_equipamento_listar")) {
				m.push({
					titulo: "* Aluguel de equipamento",
					titulo_app: "Aluguel",
					icon: "mdi-hammer-screwdriver",
					to: "/aluguel-equipamento",
					tooltip: "Tela de aluguel de equipamentos",
				});
			}

			if (this.permissao("aluguel_equipamento_listar")) {
				m.push({
					titulo: "* Equipamentos",
					titulo_app: "Equipamentos",
					icon: "mdi-toolbox-outline",
					to: "/aluguel-equipamento/lista",
					tooltip: "Lista de equipamentos para aluguel",
				});
			}

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>